import { iDocTranslateDataMap } from './docTranslate.type';

import {
  docTranslateEffects,
  docTranslateReducers,
} from './docTranslate.operator';

// DocTranslate 初始状态
export const docTranslateInitData: iDocTranslateDataMap = {};

// Model
export const docTranslateModel = {
  state: docTranslateInitData,
  reducers: docTranslateReducers,
  effects: docTranslateEffects,
};
